import { QuestionCircleOutlined } from "@ant-design/icons";
import { Modal } from "antd";
import { theme } from "../assets/theme/theme";
import styled from "styled-components";

export const ShowCloseModal = (closeDrawer: () => void, t: any) => {
  return function () {
    Modal.confirm({
      title: <HeaderText>{t("common.modal.closeConfirmTitle")}</HeaderText>,
      icon: <QuestionCircleOutlined style={{ color: theme.colors.green }} />,
      content: t("story.modal.close"),
      okText: t("common.buttonsText.confirm"),
      cancelText: t("common.buttonsText.cancel"),
      onOk: closeDrawer
    });
  };
};

export const HeaderText = styled.span`
  font-weight: 600;
  font-size: 16px;
`;
